import React, { FC, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router';

import { EvLinkNavigationTabs, IMenuOption } from '@evinced-private/ui-common';

import { TABS_DAID } from 'data-automation-ids/data-automation-ids';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { SessionViews } from 'src/common/types/WfaSessionViews';

import { MOBILE_SDK_SINGLE_TEST_TABS_LABELS } from './MobileSdkSingleTestTabs.labels';

interface IMobileSdkSingleTestTabsProps {
	viewId?: SessionViews;
	testId: string;
	showScansTab: boolean;
}

export const MobileSdkSingleTestTabs: FC<IMobileSdkSingleTestTabsProps> = ({
	testId,
	viewId = SessionViews.OVERVIEW,
	showScansTab
}) => {
	const history = useHistory();

	const handleTabClick = useCallback(
		(tabViewId: SessionViews): void =>
			history.push(RoutesHelper.getMobileSdkTestPath(testId, tabViewId)),
		[history, testId]
	);

	const options: IMenuOption[] = useMemo(
		() => [
			{
				id: SessionViews.OVERVIEW,
				title: MOBILE_SDK_SINGLE_TEST_TABS_LABELS.OVERVIEW,
				onClick: () => handleTabClick(SessionViews.OVERVIEW)
			},
			...(showScansTab
				? [
						{
							id: SessionViews.SCANS,
							title: MOBILE_SDK_SINGLE_TEST_TABS_LABELS.SCANS,
							onClick: () => handleTabClick(SessionViews.SCANS)
						}
					]
				: []),
			{
				id: SessionViews.ALL_ISSUES,
				title: MOBILE_SDK_SINGLE_TEST_TABS_LABELS.ALL_ISSUES,
				onClick: () => handleTabClick(SessionViews.ALL_ISSUES)
			}
		],
		[handleTabClick, showScansTab]
	);

	return (
		<div data-automation-id={TABS_DAID}>
			<EvLinkNavigationTabs selectedTabId={viewId} options={options} />
		</div>
	);
};
